export enum CacheKeys {
  ErrorMessages = 'errorMessages',
}
